import BaseInteractableGeometry from "./base-interactable";

class InteractableSphere extends BaseInteractableGeometry {
    constructor() {
        super();

        this._radius = 1;

        this.radius = 1;
    }

    _createMesh() {
        const geometry = new THREE.SphereBufferGeometry(1, 64, 64);
        const material = new THREE.MeshPhongMaterial({ color: this.colorMesh, transparent: false, opacity: 1 });

        const mesh = new THREE.Mesh(geometry, material);

        mesh.castShadow = true;

        return mesh;
    }

    _createColliders() {

        const { mesh: radiusMesh, collider: radiusCollider } = this._createAxisCollider({
            halfWidth: true,
            interactableType: "radius"
        });

        const { mesh: circumferenceMesh, collider: circumferenceCollider } = this._createRingCollider({
            interactableType: "radius"
        });

        const colliders = {
            radius: radiusCollider,
            circumference: circumferenceCollider
        };


        return { objects: [radiusMesh, circumferenceMesh], colliders, htmls: [] };
    }

    get radius() { return this._radius; }
    get circumference() { return 2 * Math.PI * this._radius; }
    get volume() { return (4 * Math.PI * Math.pow(this._radius, 3) / 3); }
    get surfaceArea() { return 4 * Math.PI * Math.pow(this._radius, 2); }

    get formulas() {
        return [{
            name: "radius",
            formula: [{ text: "r", key: "radius" }]
        }, {
            name: "circumference",
            formula: [{ text: "2 * PI * " }, { text: "r", key: "radius" }]
        },
        {
            name: "volume", formula: [
                { text: "4 / 3 * PI * " },
                { text: "r^3", key: "radius" }
            ]
        }, {
            name: "surfaceArea", formula: [
                { text: "4 * PI * " },
                { text: "r ^ 2", key: "radius" }
            ]
        }];
    }

    set radius(v) {
        this._radius = v;

        const axes = ["x", "y", "z"];

        this.objects.forEach(o => {
            axes.forEach(axis => {
                o.scale[axis] = v;
            });

            o.position.y = v;
        });
    }
}

export default InteractableSphere;
export { InteractableSphere };